<template>
  <v-container fluid>
    <v-card>
      <v-toolbar
        color="indigo"
        dark>

        <v-toolbar-title>
          <v-icon left>{{ filtersIcon }}</v-icon>
          {{ $vuetify.lang.t('$vuetify.charts.filters.title') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="showContent = !showContent">
          <v-icon>{{ showContent ? upIcon : downIcon }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expand-transition>
        <div v-show="showContent">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <datetime-chart-filter :start-date="`${localFilters.date.start.date}`"
                                       :finish-date="`${localFilters.date.finish.date}`"
                                       :header="$vuetify.lang.t('$vuetify.charts.filters.date.title')"
                                       @datetime-changed="setDatetime"></datetime-chart-filter>
              </v-col>
              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    <drivers-search-autocomplete @driver-choice="setDriver"></drivers-search-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <period-chart-filter @period-changed="setPeriod" class="mt-3"></period-chart-filter>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" tile @click="updateFilters" class="mx-2 mb-2">
              <v-icon left>{{ applyFiltersIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.shared.apply') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- charts -->
    <v-row>
      <v-col cols="12" md="8">
        <critical-events-distirbution :filters="filters"></critical-events-distirbution>
      </v-col>
      <v-col cols="12" md="4">
        <critical-events-doughnut :filters="filters"></critical-events-doughnut>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CriticalEventsDistirbution from '../../components/charts/CriticalEventsDistirbution'
import CriticalEventsDoughnut from '../../components/charts/CriticalEventsDoughnut'
import DriversSearchAutocomplete from '../../components/charts/DriversSearchAutocomplete'
import DatetimeChartFilter from '../../components/charts/utils/datetimeChartFilter'
import PeriodChartFilter from '../../components/charts/utils/periodChartFilter'
import { mdiFilterMenu, mdiFilterOutline } from '@mdi/js'
import { defaultChartDatetimeState } from '../../utils/filters'
import clone from 'lodash.clonedeep'
import showContentMixin from '../../mixins/showContentMixin'
import { getCurrentTime } from '../../utils/time'

// const _currentYear = (new Date()).getFullYear()
// const _currentMonth = `${new Date().getMonth() + 1}`.padStart(2, '0')
// const _lastDay = `${(new Date(_currentYear, new Date().getMonth() + 1, 0)).getDate()}`.padStart(2, '0')

const { _currentYear, _currentMonth, _lastDay } = getCurrentTime()

const getDefaultFilters = () => ({
  date: {
    start: defaultChartDatetimeState(`${_currentYear}-01-01`),
    finish: defaultChartDatetimeState(`${_currentYear}-${_currentMonth}-${_lastDay}`)
  },
  period: 'month',
  driver: null
})

export default {
  name: 'Charts',
  components: {
    PeriodChartFilter,
    DatetimeChartFilter,
    DriversSearchAutocomplete,
    CriticalEventsDoughnut,
    CriticalEventsDistirbution
  },
  mixins: [showContentMixin(false)],
  data: () => ({
    driver: null,
    currentYear: _currentYear,
    currentMonth: _currentMonth,

    filters: getDefaultFilters(), // will be passed to charts directly and they will rerender manually
    localFilters: getDefaultFilters(), // local copy for filter card only

    filtersIcon: mdiFilterMenu,
    applyFiltersIcon: mdiFilterOutline
  }),
  methods: {
    setDriver (driver) {
      this.localFilters.driver = driver
    },
    setPeriod (period) {
      this.localFilters.period = period
    },
    setDatetime (datetime) {
      this.localFilters.date[datetime.type][datetime.mode] = datetime.value
    },
    updateFilters () {
      this.filters = clone(this.localFilters)
    }
  }
}
</script>

<style scoped>

</style>
